export default "__VITE_PUBLIC_ASSET__9e79fde6__"